<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="modal-content relative bg-white pt-7">
                <div class="group relative">
                    <img v-if="isShowClose" class="absolute right-6" @click="closePdpa()" src="@/assets/icon/sidebar/close_blue.svg">
                    <div class="font-main-regular text-lg text-center
                        text-blue-2 uppercase leading-normal pt-0.5 pb-5 px-7"
                        v-html="title">
                    </div>
                </div>
                <Pdpa
                    :ref="'termsAndPrivacy'"
                    class="pdpa-content px-7"
                    :class="showConfirmBtn ? 'pb-32': ''"
                    :localeCode="localeCode"
                    :type="type"
                    :version="version">
                </Pdpa>
                <div v-if="showConfirmBtn" class="fixed bottom-0 left-0 px-8 py-6 w-full bg-white">
                    <VBtn
                        blocked
                        large
                        variant="primary"
                        @click="clickAccept()"
                    >{{ lbl.default.accept }}</VBtn>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" @click="closePdpa()"></div>
    </transition>
</template>
<script>
//mixins
import LocaleMixin from "@/mixin/LocaleMixin.js";
//components
import Pdpa from "@/components/PDPA/Pdpa.vue";
import VBtn from "@/components/Button/VBtn.vue"
export default {
    name: "PdpaModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function () {
        return {
            open: false,
            title: '',
            type: null,
            busModal: null,

            showConfirmBtn: false,
            initFirst: false,

            version: null,
            isShowClose: true,
        };
    },
    components: {
        Pdpa,
        VBtn
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function (config) {
            this.title = config.title;
            this.type = config.type;
            this.showConfirmBtn = config.showConfirmBtn;
            this.isShowClose = config.isShowClose;

            if(this.initFirst && this.showConfirmBtn) {
                this.$refs.termsAndPrivacy.initialPDPA()
            }

            document.body.classList.add('not-scroll');
            this.initFirst = true
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        closePdpa: function () {
            this.hide();
        },
        clickAccept: function() {
            // this.hide();
            this.controller.sendCallbackAccept({ tag: this.type });
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";
.modal {
    @extend %modal;
    top: unset;
    .modal-content {
        width: 100%;
        height: 90vh;
        border-top-left-radius: 28px;
        border-top-right-radius: 28px;
        .pdpa-content{
            height: calc(90vh - 77px);
            overflow: scroll;
        }
    }
    .label {
        background-image: url("~@/assets/button/bg.svg");
        background-size: 100%;
    }
}
</style>
